import Swal from "sweetalert2";
import highlightSection from "../../utils/highlightSection";
import isADevice from "../../utils/isADevice";
const OTHER_VEHICLES_MAX_VALUE = 700_000;

async function validationVehicle(
  callback = async () => {},
  vehicleData,
  vehicleYearSelectRef
) {
  if (
    vehicleData.valueUser === undefined ||
    vehicleData.valueUser === null ||
    isNaN(vehicleData.valueUser) ||
    !isFinite(vehicleData.valueUser)
  ) {
    Swal.fire({
      icon: "warning",
      text: "Ingresa un valor comercial válido",
    }).then(() => {
      highlightSection("valueUser");
    });
    return;
  }

  if (vehicleData.brand.trim() === "") {
    Swal.fire({
      icon: "warning",
      text: "Selecciona la marca de tu vehículo",
    }).then(() => {
      highlightSection("brand");
    });
  } else if (vehicleData.model.trim() === "" && vehicleData.brand !== "Otro") {
    Swal.fire({
      icon: "warning",
      text: " Selecciona el modelo de tu vehículo",
    }).then(() => {
      highlightSection("model");
    });
  } else if (
    (vehicleData.type === "auto" || vehicleData.type === "moto") &&
    vehicleData.year === ""
  ) {
    Swal.fire({
      icon: "warning",
      text: " Selecciona el año de tu vehículo",
    }).then(() => {
      highlightSection("year");
    });
  } else if (
    (vehicleData.valueUser < 5000 || !vehicleData.valueUser) &&
    vehicleData.type !== "otro"
  ) {
    Swal.fire({
      icon: "warning",
      text: " El valor de tu vehículo es menor a $5,000, el valor comercial mínimo es de $5,000",
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (!isADevice(vehicleData.type) && vehicleData.features.length <= 0) {
    Swal.fire({
      icon: "warning",
      text: "Por favor, selecciona las características de tu vehículo",
    }).then(() => {
      highlightSection("product-features");
    });
  } else if (
    (vehicleData.type === "auto" || vehicleData.type === "moto") &&
    vehicleData.valueUser > 1500000
  ) {
    Swal.fire({
      icon: "warning",
      text: `El valor de tu ${vehicleData.type} no puede ser mayor a $1,500,000`,
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (vehicleData.type === "auto" && vehicleData.valueUser < 30000) {
    Swal.fire({
      icon: "warning",
      text: "El valor de tu auto no puede ser menor a $30,000",
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    vehicleData.type === "moto" &&
    vehicleData.brand === "BMW" &&
    vehicleData.model !== "S 1000 RR" &&
    vehicleData.valueUser > 650000
  ) {
    Swal.fire({
      icon: "warning",
      text: "El valor de tu moto no puede ser mayor a $650,000",
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    vehicleData.type === "moto" &&
    vehicleData.valueUser > 760_000 &&
    vehicleData.brand === "Harley-Davidson" &&
    vehicleData.model !== "CVO TRI-GLIDE - DANTES RED FADE" &&
    vehicleData.model !== "PURSUIT DARK HORSE" &&
    vehicleData.model !== "FLTFTXSE CVO ROAD GLIDE" &&
    vehicleData.model !== "FLTRK ROAD GLIDE LIMITED" &&
    vehicleData.model !== "FLHXST STREET GLIDE SPECIAL ST" &&
    vehicleData.model !== "FLTRKSE CVO ROAD GLIDE LIMITED" &&
    vehicleData.model !== "FLHXS STREET GLIDE SPECIAL"
  ) {
    Swal.fire({
      icon: "warning",
      text: "El valor de tu moto no puede ser mayor a $600,000",
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    vehicleData.type === "moto" &&
    vehicleData.valueUser > 1300000 &&
    vehicleData.model === "CVO TRI-GLIDE - DANTES RED FADE" &&
    vehicleData.brand === "Harley-Davidson"
  ) {
  } else if (
    vehicleData.type === "moto" &&
    vehicleData.valueUser > 608000 &&
    vehicleData.model === "PURSUIT DARK HORSE" &&
    vehicleData.brand === "Indian"
  ) {
    Swal.fire({
      icon: "warning",
      text: "El valor de tu moto no puede ser mayor a $608,000",
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    vehicleData.type === "moto" &&
    vehicleData.valueUser > 1300000 &&
    vehicleData.model === "CVO TRI-GLIDE - DANTES RED FADE" &&
    vehicleData.brand === "Harley-Davidson"
  ) {
  } else if (
    vehicleData.type === "moto" &&
    vehicleData.valueUser > 675400 &&
    vehicleData.model === "FLTFTXSE CVO ROAD GLIDE" &&
    vehicleData.brand === "Harley-Davidson"
  ) {
    Swal.fire({
      icon: "warning",
      text: "El valor de tu moto no puede ser mayor a $675,400",
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    vehicleData.type === "moto" &&
    vehicleData.valueUser > 1300000 &&
    vehicleData.model === "CVO TRI-GLIDE - DANTES RED FADE" &&
    vehicleData.brand === "Harley-Davidson"
  ) {
    Swal.fire({
      icon: "warning",
      text: "El valor de tu moto no puede ser mayor a $1,300,000",
    });
  } else if (
    vehicleData.type === "moto" &&
    vehicleData.valueUser > 750000 &&
    vehicleData.model === "FLHXS STREET GLIDE SPECIAL" &&
    vehicleData.brand === "Harley-Davidson"
  ) {
    Swal.fire({
      icon: "warning",
      text: "El valor de tu moto no puede ser mayor a $750,000",
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    vehicleData.type === "moto" &&
    vehicleData.valueUser > 750000 &&
    vehicleData.model === "FLHXST STREET GLIDE SPECIAL ST" &&
    vehicleData.brand === "Harley-Davidson"
  ) {
    Swal.fire({
      icon: "warning",
      text: "El valor de tu moto no puede ser mayor a $750,000",
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    vehicleData.type === "moto" &&
    vehicleData.valueUser > 777800 &&
    vehicleData.model === "FLTRK ROAD GLIDE LIMITED" &&
    vehicleData.brand === "Harley-Davidson"
  ) {
    Swal.fire({
      icon: "warning",
      text: "El valor de tu moto no puede ser mayor a $777,800",
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    vehicleData.type === "moto" &&
    vehicleData.valueUser > 1356000 &&
    vehicleData.model === "FLTRKSE CVO ROAD GLIDE LIMITED" &&
    vehicleData.brand === "Harley-Davidson"
  ) {
    Swal.fire({
      icon: "warning",
      text: "El valor de tu moto no puede ser mayor a $1,356,000",
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    vehicleData.type === "eBike" &&
    vehicleData.valueUser > 300000 &&
    vehicleData.brand === "TURBO"
  ) {
    Swal.fire({
      icon: "warning",
      text: "El valor de tu moto no puede ser mayor a $300,000",
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    vehicleData.type === "eBike" &&
    vehicleData.valueUser > 247000 &&
    vehicleData.brand === "Specialized"
  ) {
    Swal.fire({
      icon: "warning",
      text: "El valor de tu moto no puede ser mayor a $247,000",
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    vehicleData.type === "otro" &&
    vehicleData.valueUser > 344800 &&
    vehicleData.brand === "CAN-AM" &&
    vehicleData.model === "COMMANDER MAX XT"
  ) {
    Swal.fire({
      icon: "warning",
      text: "El valor de tu moto no puede ser mayor a $344,800",
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    vehicleData.type === "otro" &&
    vehicleData.valueUser > 230000 &&
    vehicleData.brand === "CFMOTO" &&
    vehicleData.model.toUpperCase() !== "CFORCE 625 TOURING"
  ) {
    Swal.fire({
      icon: "warning",
      text: "El valor de tu vehículo no puede ser mayor a $230,000",
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    vehicleData.type === "otro" &&
    vehicleData.valueUser > 323900 &&
    vehicleData.brand === "CAN-AM" &&
    vehicleData.model === "MAVERICK SPORT M"
  ) {
    Swal.fire({
      icon: "warning",
      text: "El valor de tu moto no puede ser mayor a $323,900",
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    vehicleData.type === "otro" &&
    vehicleData.valueUser > 799990 &&
    vehicleData.brand === "Kawasaki" &&
    vehicleData.model === "Teryx 4 KRX 1000 EDICION ESPECIAL"
  ) {
    Swal.fire({
      icon: "warning",
      text: "El valor de tu moto no puede ser mayor a $799,990",
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    (vehicleData.type === "bike" || vehicleData.type === "eBike") &&
    vehicleData.valueUser > 300000
  ) {
    Swal.fire({
      icon: "warning",
      text: `El valor de tu ${
        vehicleData.type === "bike" ? "bicicleta" : "bicicleta eléctrica"
      } no puede ser mayor a $300,000`,
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    (vehicleData.type === "otro" || vehicleData.type === "scooter") &&
    vehicleData.valueUser > OTHER_VEHICLES_MAX_VALUE &&
    !vehicleData.brand.toUpperCase().includes("CAN-AM") &&
    !vehicleData.brand.toUpperCase().includes("CF MOTO") &&
    vehicleData.brand !== "TURBO" &&
    vehicleData.model !== "LEVO" &&
    vehicleData.brand !== "Specialized" &&
    vehicleData.model !== "Turbo Levo Expert" &&
    vehicleData.model !== "Teryx 4 KRX 1000 EDICION ESPECIAL"
  ) {
    Swal.fire({
      icon: "warning",
      text: `El valor de tu vehículo no puede ser mayor a $${OTHER_VEHICLES_MAX_VALUE.toLocaleString(
        "en-US"
      )}`,
    }).then(() => {
      highlightSection("valueUser");
    });
  } else if (
    vehicleData.features.includes("Soy conductor de plataforma") &&
    vehicleData.platforms.length === 0
  ) {
    Swal.fire({
      icon: "warning",
      text: "Selecciona al menos una plataforma",
    });
  } else {
    try {
      await callback();
    } catch (e) {
      console.error(e);
    }
  }
}

export default validationVehicle;
